import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/index.styles'

const AccommodationPMSMappingBox = () => {
  const classes = useStyles()
  return (
    <div>
      <div className={classes.skeletonContainer}>
        <Skeleton animation="wave" className={classes.skeletonUp} />
        <div className={classes.skeletonContainerDown}>
          <Skeleton animation="wave" className={classes.skeletonDownFirst} />
          <Skeleton animation="wave" className={classes.skeletonDown} />
          <Skeleton animation="wave" className={classes.skeletonDown} />
        </div>
      </div>
    </div>
  )
}

export default AccommodationPMSMappingBox
